import { createFileRoute, redirect } from '@tanstack/react-router'
import { editSiteSearch } from 'routes/organization_/site/-searchParams'
import { Route as NewRoute } from 'routes/organization_/site/index'
import { z } from 'zod'

const deprecatedSiteDetailsSearchParams = z.object({
  mode: z.literal('edit'),
})

export const Route = createFileRoute(
  '/organization_/(deprecated_routes)/$orgID/site/$siteID'
)({
  validateSearch: deprecatedSiteDetailsSearchParams,
  beforeLoad: ({ params }) => {
    throw redirect({
      to: NewRoute.to,
      search: editSiteSearch(params.orgID, params.siteID),
      replace: true,
    })
  },
})
